/**
 * Checks if the given item is an object.
 *
 * @param item - The item to be checked.
 * @returns A boolean indicating whether the item is an object or not.
 */
const isObject = (item: unknown): item is Record<string, unknown> => {
    return typeof item === "object" && item !== null && !Array.isArray(item);
};

export { isObject };
